import { DateTimePicker, InputFormCallout, InputFormCalloutProps } from "o4a-react";
import * as React from "react";
import { Text } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { Settings, SettingsContext } from "../../console/SettingsContext";

export const enum Fields {
  Timestamp = "timestamp",
}
// eslint-disable-next-line max-len
export type AdbsBackupRestorePanelProps = Pick<InputFormCalloutProps, "targetId" | "onClose" | "onSubmit" | "componentRef">;

export const AdbsBackupRestorePanel = ({
  targetId,
  componentRef,
  onClose,
  onSubmit,
}: AdbsBackupRestorePanelProps): JSX.Element => {
  const { locale } = React.useContext<Settings>(SettingsContext);
  return (
    <InputFormCallout
      componentRef={componentRef}
      title={Messages.createNewPanels.restore.title()}
      targetId={targetId}
      onClose={onClose}
      onSubmit={onSubmit}
      primaryButtonText={Messages.actions.restore()}
    >
      <Text>
        {Messages.createNewPanels.restore.restoreDbToPoint()}
      </Text>
      <DateTimePicker
        label={Messages.labels.enterTimestamp()}
        locale={locale}
        fieldName={Fields.Timestamp}
        tooltip={Messages.hints.toolTipRestoreAdbsTime()}
        minDate={new Date(Date.now() - 60 * 24 * 3600 * 1000)}
      />
    </InputFormCallout>
  );
};
